import { useState } from 'react';
import HelpSharpIcon from '@mui/icons-material/HelpSharp';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { styled } from '@mui/material';

interface HelpIconProps {
  title: string;
  tooltipProps?: TooltipProps;
}
/**
 * Icon, including helptext and a tooltip which displays on hover / click
 */
export const HelpIcon = ({ title, tooltipProps }: HelpIconProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [hover, setHover] = useState<boolean>(false);
  return (
    <ClickAwayListener
      onClickAway={() => {
        setOpen(false);
        setHover(false);
      }}
      touchEvent='onTouchStart'
      mouseEvent='onMouseDown'
      disableReactTree
    >
      {
        // span is here because the child of the clickaway needs to be able to hold a ref
      }
      <span>
        <CustomTooltip
          open={open || hover}
          title={title}
          enterDelay={100}
          leaveDelay={100}
          {...tooltipProps}
        >
          <HelpSharpIcon
            color='primary'
            fontSize='small'
            onClick={() => setOpen((oldOpen) => !oldOpen)}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => {
              setOpen(false);
              setHover(false);
            }}
          />
        </CustomTooltip>
      </span>
    </ClickAwayListener>
  );
};

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => {
  return {
    [`& .${tooltipClasses.tooltip}`]: {
      fontSize: '0.9rem',
      backgroundColor: theme.palette.primary.main,
      padding: '8px',
    },
  };
});
